import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Button, DialogActions } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

type InfoDialogType = {
  handleClose(): void;
  open: boolean;
  title: string;
  dialogInformation: React.ReactNode;
  showActions?: boolean;
  handleSubmit?(): void;
};

export default function InfoDialog({
  handleClose,
  open,
  title,
  dialogInformation,
  showActions = false,
  handleSubmit,
}: InfoDialogType) {
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{dialogInformation}</DialogContent>
      {showActions ? (
        <DialogActions>
          <Button
            role="button"
            variant="contained"
            onClick={handleSubmit}
            sx={{
              padding: "7px 28px",
              borderRadius: "20px",
              fontSize: "16px",
              boxShadow: "none",
              marginBottom: "10px",
            }}
          >
            Send Invite
          </Button>
        </DialogActions>
      ) : null}
    </BootstrapDialog>
  );
}
